// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import SwaggerUI from 'swagger-ui'

// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from 'bootstrap';

import 'chartkick/chart.js'

import JSONEditor from "jsoneditor"
window.JSONEditor = JSONEditor

// for json syntax highlighting
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'

import './web_components/central-module-software-update.umd'

require('@rails/activestorage').start()
//require('channels')

import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false
Turbo.config.forms.mode = "optin" // other possible values: "on" | "off"

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
//require('stylesheets/application.css')

// add frontend css for custom login
//require('stylesheets/frontend.css')
hljs.registerLanguage('json', json)

// code highlighting for json configs etc.
document.addEventListener('turbo:load', (event) => {
  document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightElement(block)
  })
})

// Add Swagger UI for frontend api docs
// If turbolinks are deactivated use the Event 'DOMContentLoaded' instead
document.addEventListener('turbo:load', (event) => {
  const element = document.getElementById('swagger_frontend_api_docs')
  if (element != null) {
    const spec = require('../../docs/swagger_frontend.yaml')
    SwaggerUI({
      spec,
      dom_id: '#swagger_frontend_api_docs'
    })
  }
})

// Add Swagger UI for device api docs
// If turbolinks are deactivated use the Event 'DOMContentLoaded' instead
document.addEventListener('turbo:load', (event) => {
  const element = document.getElementById('swagger_device_api_docs')
  if (element != null) {
    const spec = require('../../docs/swagger_central_module.yaml');
    SwaggerUI({
      spec,
      dom_id: '#swagger_device_api_docs'
    })
  }
})

